import { render, staticRenderFns } from "./OrderCardShipment.vue?vue&type=template&id=06fdc80c&scoped=true"
import script from "./OrderCardShipment.vue?vue&type=script&lang=ts"
export * from "./OrderCardShipment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fdc80c",
  null
  
)

export default component.exports